const ShelfProductDetailService = function ShelfProductDetailService(Restangular, $rootScope, breakpointsService) {
    this._api = Restangular.one('product');
    this.breakpointsService = breakpointsService;

    // We invalidate when the trolley updates because product detail
    // objects contain information about quantity in trolley.
    $rootScope.$on('trolley:update', () => {
        this.invalidate();
    });
};

let detailsCache = {};

ShelfProductDetailService.prototype.getProductDetail = function (productStockcode, aisle, category, validateUrl) {
    if (!(productStockcode in detailsCache)) {
        detailsCache[productStockcode] = this._api.one('detail', productStockcode).get({
            aisle, category, validateUrl, isMobile: this.breakpointsService.isInSmallFormat,
        });
    }

    return detailsCache[productStockcode];
};

ShelfProductDetailService.prototype.invalidate = function () {
    detailsCache = {};
};

module.exports = ShelfProductDetailService;



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelfproduct-detail.service.js